import { AssetId } from "@carnegie-learning/common-types";
import { Asset } from "@carnegie-learning/cure-types";
import { AssignmentPagination, AssignmentPaginationParameters } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store"; // Action is an interface of type string
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";

// ------ Load Assignments ------
export const LOAD_STUDENT_ASSIGNMENTS =
    "[Assignments] Load Student Assignments";
export const LOAD_STUDENT_ASSIGNMENTS_FAIL =
    "[Assignments] Load Student Assignments Fail";
export const LOAD_STUDENT_ASSIGNMENTS_SUCCESS =
    "[Assignments] Load Student Assignments Success";
export const LoadStudentAssignments = createAction(
    LOAD_STUDENT_ASSIGNMENTS,
    props<{
        payload: AssignmentPaginationParameters;
    }>()
);
export const LoadStudentAssignmentsFail = createAction(
    LOAD_STUDENT_ASSIGNMENTS_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadStudentAssignmentsSuccess = createAction(
    LOAD_STUDENT_ASSIGNMENTS_SUCCESS,
    props<{
        AssignmentPaginationData: AssignmentPagination;
    }>()
);

// ------ Load assignment ------
export const LOAD_STUDENT_ASSIGNMENT = "[Assignments] Load Student Assignment";
export const LOAD_STUDENT_ASSIGNMENT_FAIL =
    "[Assignments] Load Student Assignment Fail";
export const LOAD_STUDENT_ASSIGNMENT_SUCCESS =
    "[Assignments] Load Student Assignment Success";

export const LoadStudentAssignment = createAction(
    LOAD_STUDENT_ASSIGNMENT,
    props<{
        assignmentID: number;
    }>()
);
export const LoadStudentAssignmentFail = createAction(
    LOAD_STUDENT_ASSIGNMENT_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadStudentAssignmentSuccess = createAction(
    LOAD_STUDENT_ASSIGNMENT_SUCCESS,
    props<{ assignment: Assignment }>()
);

export const updateStudentAssignment = createAction(
    "[Assignments] Update Student Assignment",
    props<{
        assignmentID: number;
    }>()
);

export const updateStudentAssignmentFail = createAction(
    "[Assignments] Update Student Assignment Fail",
    props<{ payload: any }>()
);
export const updateStudentAssignmentSuccess = createAction(
    "[Assignments] Update Student Assignment Success",
    props<{ assignment: Assignment }>()
);

// Set Transaction ID for retieving an Assignment
export const SetStudentTransIdForAssignment = createAction(
    "[Assignment] Set TransactionID",
    props<{ transactionID: string }>()
);

// ------ Get assignment Id based on transactionID ------
export const GetStudentAssignmentFromTransIdFail = createAction(
    "[Assignments] Get Student Assignment ID Fail",
    props<{
        payload: any;
    }>()
);
export const GetStudentAssignmentFromTransIdSuccess = createAction(
    "[Assignments] Get Student Assignment ID Success",
    props<{ assignment: Assignment }>()
);

// ------ Update To Do Assignment ------
export const UPDATE_STUDENT_ASSIGNMENT = "[Assignments] Update Assignment";
export const UPDATE_STUDENT_ASSIGNMENT_FAIL =
    "[Assignments] Update Assignment Fail";
export const UPDATE_STUDENT_ASSIGNMENT_SUCCESS =
    "[Assignments] Update Assignment Success";

export const UpdateStudentAssignment = createAction(
    UPDATE_STUDENT_ASSIGNMENT,
    props<{ payload: Assignment }>()
);
export const UpdateStudentAssignmentFail = createAction(
    UPDATE_STUDENT_ASSIGNMENT_FAIL,
    props<{ payload: any }>()
);

export const UpdateStudentAssignmentSuccess = createAction(
    UPDATE_STUDENT_ASSIGNMENT_SUCCESS,
    props<{ payload: Assignment }>()
);

// ------ Set Selected Assignment ------
export const SET_SELECTED_ASSIGNMENT = "[Assignment] Set Selected Assignment";

export const SetSelectedAssignment = createAction(
    SET_SELECTED_ASSIGNMENT,
    props<{ payload: Assignment }>()
);

// ------ Set Selected AssignmentID ------
export const SET_SELECTED_ASSIGNMENTID =
    "[Assignment] Set Selected AssignmentID";

export const SetSelectedAssignmentID = createAction(
    SET_SELECTED_ASSIGNMENTID,
    props<{ payload: number }>()
);

// ------ Set Selected Assignment ActivityID ------
export const SET_SELECTED_ASSIGNMENT_ACTIVITYID =
    "[Assignment] Set Selected Assignment ActivityID";

export const SetSelectedAssignmentActivityID = createAction(
    SET_SELECTED_ASSIGNMENT_ACTIVITYID,
    props<{ payload: number }>()
);

// ------ Set Pagination Params ------
export const SET_PAGINATION_PARAMS = "[Assignment] Set Pagination Params";

export const SetPaginationParams = createAction(
    SET_PAGINATION_PARAMS,
    props<{ payload: any }>() // Uses a AssignmentPaginationParameters, but we don't want to require the user to complete the object.
);

// ------ Set Display Filter Params ------
export const SET_DISPLAY_FILTER_PARAMS =
    "[Assignment] Set Display Filter Params";

export const SetDisplayFilterParams = createAction(
    SET_DISPLAY_FILTER_PARAMS,
    props<{ payload: any }>()
);

// ------ ClearAssignments ------
export const CLEAR_ASSIGNMENTS = "[Assignments] Clear Assignments";
export const ClearAssignments = createAction(CLEAR_ASSIGNMENTS);

// ------ ClearAssignmentEntities ------
export const CLEAR_ASSIGNMENT_ENTITIES =
    "[Assignments] Clear Assignment Entities";
export const ClearAssignmentEntities = createAction(CLEAR_ASSIGNMENT_ENTITIES);

// ------ Set Assignment Launched in New Tab ------
export const SET_LAUNCHED_IN_NEW_TAB = "[Assignment] Set Launched In New Tab";

export const SetLaunchedInNewTab = createAction(
    SET_LAUNCHED_IN_NEW_TAB,
    props<{ payload: number }>()
);

// ------ Load Assignment Asset ------
export const LOAD_ASSIGNMENT_ASSET = "[Assignment] Load Assignment Asset";
export const LOAD_ASSIGNMENT_ASSET_FAIL =
    "[Assignment] Load Assignment Asset Fail";
export const LOAD_ASSIGNMENT_ASSET_SUCCESS =
    "[Assignment] Load Assignment Asset Success";
export const LoadAssignmentAsset = createAction(
    LOAD_ASSIGNMENT_ASSET,
    props<{
        assignmentId: number;
        assetId: AssetId;
    }>()
);
export const LoadAssignmentAssetFail = createAction(
    LOAD_ASSIGNMENT_ASSET_FAIL,
    props<{
        payload: any;
    }>()
);
export const LoadAssignmentAssetSuccess = createAction(
    LOAD_ASSIGNMENT_ASSET_SUCCESS,
    props<{
        assignmentId: number;
        asset: Asset;
    }>()
);

// ------ Load All Assignment Asset ------
export const LoadAllStudentAssignmentAssets = createAction(
    "[Assignment] Load All Student Assignment Assets",
    props<{
        assignments: Assignment[];
    }>()
);
export const LoadAllStudentAssignmentAssetsFail = createAction(
    "[Assignment] Load All Student Assignment Assets Fail",
    props<{
        payload: any;
    }>()
);
export const LoadAllStudentAssignmentAssetsSuccess = createAction(
    "[Assignment] Load All Student Assignment Assets Success",
    props<{
        assignments: Assignment[];
        assets: Asset[];
    }>()
);

// ------ Load Bundle Assignments Asset ------
export const loadBundleAssignmentsAssets = createAction(
    "[Assignment] Load Bundle Assignments Assets",
    props<{
        bundleAssetId: string;
        compositeTaskAssignments: CompositeTaskAssignment[];
    }>()
);
export const loadBundleAssignmentsAssetsFail = createAction(
    "[Assignment] Load Bundle Assignments Assets Fail",
    props<{
        payload: any;
    }>()
);
export const loadBundleAssignmentsAssetsSuccess = createAction(
    "[Assignment] Load Bundle Assignments Assets Success",
    props<{
        bundleAssetId: string;
        compositeTaskAssignments: CompositeTaskAssignment[];
        assets: Asset[];
    }>()
);

export const setAssignmentMarkedAsRead = createAction(
    "[Assignment] Set Assignment Marked As Read",
    props<{
        assignment: Assignment;
    }>()
);
export const setAssignmentMarkedAsReadFail = createAction(
    "[Assignment] Set Assignment Marked As Read Fail",
    props<{
        payload: Error;
    }>()
);
export const setAssignmentMarkedAsReadSuccess = createAction(
    "[Assignment] Set Assignment Marked As Read Success"
);
